module.exports = "pegasus_template/assets/blocks/header-5-theme3.png";